<template>
  <div :class="['coros-collapse', { active: active }]">
    <div
      class="collapse-header"
      @click="changeStatus"
    >
      <div class="content">
        <slot name="collapse-header">
          <span>{{ title }}</span>
        </slot>
      </div>
      <i class="iconfont iconicon_jichutubiao_jiantou_xiala status-icon"></i>
    </div>
    <div
      ref="panel"
      class="panel"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  title: { type: [String, Number], default: () => {} },
  active: { type: Boolean, default: () => {} }
});

const emit = defineEmits(['toggle']);
function changeStatus() {
  emit('toggle');
}
</script>

<style lang="scss" scoped>
.coros-collapse {
  .collapse-header {
    padding: 0 12px;
    min-height: 32px;
    font-size: 14px;
    cursor: pointer;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    box-sizing: border-box;

    display: flex;
    flex-direction: row;
    align-items: center;

    height: 40px;
    background-color: rgba(255, 255, 255, 0.05);
    box-shadow: 0 2px 28px 0 rgba(22, 27, 43, 0.4);
    transition: background-color ease-in-out 0.2s;

    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
    }

    .content {
      flex-grow: 1;
      flex-shrink: 1;
    }

    .status-icon {
      margin-left: 8px;
      flex-grow: 0;
      flex-shrink: 0;
      font-size: 20px;
      transition: transform 0.1s linear;
      color: rgba(255, 255, 255, 0.6);
    }
  }

  .panel {
    height: 0;
    overflow: hidden;
    //transition: height 0.1s linear;
  }

  &.active {
    .collapse-header {
      .status-icon {
        transform: rotateZ(180deg);
      }
    }

    .panel {
      flex-grow: 1;
      flex-shrink: 1;
      overflow: auto;
    }
  }
}
</style>
